import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  saveWithService: {
    description: 'show the user how much they can save if they used a certain service with an added rebate',
    defaultMessage:
      'Save <savings></savings> on this shipment by choosing {serviceName} <apply>Apply</apply> <p>Included is a 50¢ rebate, offered by ShipStation on your {serviceName} shipments until Oct. 14. <link>Learn more</link></p>',
    id: '6c+qd6',
  },
  cheaperWithRebate: {
    description: 'informs the user the rate is cheaper only because of a special rebate',
    defaultMessage:
      'Save <savings></savings> on this shipment with a limited-time 50¢ rebate from ShipStation! <apply>Apply</apply> or click to <link>Learn More</link>',
    id: 'z5AVma',
  },
  rebateSelected: {
    description: 'shown when a user has the rebated service selected',
    defaultMessage: 'You’ll receive a 50¢ rebate from ShipStation on this shipment! <link>Learn More</link>',
    id: 'djAp5B',
  },
  shopAround: {
    description: 'shown when the user is using carriers we want to offer a rebate against',
    defaultMessage:
      'Choose UPS® to save an additional 50¢ per shipment with a limited time rebate from ShipStation. <link>Learn more</link>',
    id: 'A8jgZ/',
  },
  rateShopperRecommendationName: {
    defaultMessage: 'Rate Shopper',
    description: 'Name used for the Rate Shopper recommendation',
    id: 'RRKnsH',
  },
});
